import { useState } from "react";
import { Link } from "react-router-dom";
import { routes } from "../../constants";
import IconSVG from "../../styles/svg-icons";
import {
    Accordion,
    AccordionItem,
    AccordionItemBody,
    AccordionItemHeader,
} from "../common/accordion";

const faqList = [
    {
        question: "How many years of historical data do you use to determine the price?",
        answer: "The short answer is 'all.' KopenTech has 14 years of secondary trading data and 11 years of primary data. EVAL has embedded automated manager tiering methodology that relies on managers' recent prints (which can go back multiple years for less liquid managers). The models are designed to give more weight to the more recent data (last few months).",
    },
    {
        question: "How often is the dataset updated?",
        answer: "We run updates daily; however, we plan to switch to real-time updates in 2026. Our real-time updates will become even more meaningful as secondary trading on the platform increases.",
    },
    {
        question: "How many models do you use for pricing? Are they different for HY vs IG bonds?",
        answer: "There are two main schools of thought for models: rule-based and machine learning. In practice, we run around 6 different models aggregated together; some of them are indeed a better fit to price certain parts of the capital structure (such as machine learning for IG-rated securities). Many models differentiate further between HY and equity.",
    },
    {
        question: "Do you use any data from the primary market and Issuance Monitor?",
        answer: "One of the assets of KopenTech's database is the rich data on primary markets, which incorporates current prints, as well as deal marketing history, including guidance widening, tightening, and oversubscription. Our 1.0 models do not currently include this data; however, we plan to incorporate it into our daily updates starting in 2026.",
    },
    {
        question: "Does any data come from outside KopenTech?",
        answer: "KopenTech parses BWICs, dealer inventory, and primary issuance files sent by its buy-side and sell-side clients. KopenTech also relies on third-party loan pricing data and cashflow generation models.",
    },
];

export const FaqSection = () => {
    const [expandedItemIndex, setExpandedItemIndex] = useState<number | null>(null);

    return (
        <div className="eval-lp-section faq">
            <h2>F.A.Q.</h2>
            <Accordion>
                {faqList.map(({ question, answer }, index) => {
                    const isSelected = expandedItemIndex === index;
                    return (
                        <AccordionItem key={index} isSelected={isSelected}>
                            <AccordionItemHeader
                                isSelected={isSelected}
                                onItemHeaderClick={() =>
                                    setExpandedItemIndex(
                                        isSelected ? null : index
                                    )
                                }
                                isShowCollapsedIcon={false}
                            >
                                <span>{question}</span>
                                <IconSVG
                                    name={isSelected ? "minus" : "plus"}
                                    width={16}
                                    height={16}
                                />
                            </AccordionItemHeader>
                            <AccordionItemBody visible={isSelected}>
                                {answer}
                            </AccordionItemBody>
                        </AccordionItem>
                    );
                })}
            </Accordion>
            <Link className="link-read-more" to={routes.resourcesEval}>Read more on Resources</Link>
        </div>
    );
};
